import dayjs from 'dayjs';
import React from 'react';
import { styled } from 'linaria/react';
import { useStore } from 'effector-react';
import { Button, Menu, Popover, Position, toaster } from 'evergreen-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faEllipsisV,
	faSignOutAlt,
	faInfoCircle,
	faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';

import { routes } from 'src/routes';
import { history } from 'src/history';
import { user$ } from 'src/store/user.store';
import { deleteGroupFx, group$, groupMemberFx } from 'src/store/group.store';

const Icon = styled.div`
	width: 16px;
`;

export const GroupMenu = () => {
	const user = useStore(user$);
	const group = useStore(group$);

	const handleLeave = (close: () => void) => () => {
		close();
		groupMemberFx({
			type: 'remove',
			user: user?.id,
		});
	};
	const handleDetails = (close: () => void) => () => {
		close();
		history.push(routes.root.home.group.admin.url(group?.id));
	};
	const handleDeleteGroup = (close: () => void) => async () => {
		await deleteGroupFx();
		toaster.success('Box deleted');
		history.push(routes.root.home.userBoxes.path);
	};

	const isOwner = group?.owner.user.id === user?.id;
	const isExpired = dayjs(group?.distribution_date).isBefore(dayjs());

	return (
		<Popover
			position={Position.BOTTOM_RIGHT}
			content={({ close }) =>
				<Menu>
					<Menu.Item style={{ display: 'none' }}/>
					{isOwner ? <>
						<Menu.Item
							icon={<Icon><FontAwesomeIcon icon={faInfoCircle}/></Icon>}
							onClick={handleDetails(close)}
						>
							Admin
						</Menu.Item>
						<Menu.Item
							disabled={group?.distributed || isExpired}
							intent={'danger'}
							onClick={handleDeleteGroup(close)}
							icon={<Icon><FontAwesomeIcon icon={faTrashAlt} color={'#bf0e08'}/></Icon>}
						>
							Delete
						</Menu.Item>
					</> : <>
						<Menu.Item
							disabled={group?.distributed}
							intent="danger"
							onClick={handleLeave(close)}
							icon={<Icon><FontAwesomeIcon icon={faSignOutAlt} color={'#bf0e08'}/></Icon>}
						>
							Leave
						</Menu.Item>
					</>}
				</Menu>
			}
		>
			<Button
				appearance={'minimal'}
			>
				<FontAwesomeIcon
					icon={faEllipsisV}
					size={'lg'}
				/>
			</Button>
		</Popover>
	);
};
